module.exports = __webpack_public_path__ + "d4794f59f18c7ff1e649f8da6b727959.pdf";